import { deserializeDeviceEntry, serializeDeviceEntry } from './device-vault-serializer';
export class HttpDeviceVaultRepository {
    constructor(http, logger) {
        this.http = http;
        this.logger = logger;
    }
    async getDeviceVault(deviceId) {
        try {
            // query up to date vault from backend
            this.logger.logInformation('HTTP Device Vault Repository: Getting entries from backend...');
            const response = await this.http.get(`devices/${deviceId}`);
            const mapped = response.map(item => deserializeDeviceEntry(item)).sort((a, b) => a.entryId - b.entryId);
            this.logger.logInformation('HTTP Device Vault Repository: Entries successfully loaded.');
            return mapped;
        }
        catch (ex) {
            this.logger.logWarning(`HTTP Device Vault Repository: ${ex}`);
            throw ex;
        }
    }
    async addDeviceVaultEntry(deviceId, data, httpClientOptions) {
        const requests = data.map(r => serializeDeviceEntry(r));
        return await this.http.post(`devices/${deviceId}`, requests, httpClientOptions);
    }
    async deleteDeviceVault(deviceId) {
        return await this.http.delete(`devices/${deviceId}`);
    }
}
